import { isValidPhoneNumber as isLibPhoneNumberValid } from 'libphonenumber-js';
import { normalizePhoneNumberInput } from '../../lib/formatter';

export const PHONE_NUMBER_REQUIRED_ERROR = 'Номер телефона обязателен к заполнению';
export const PHONE_NUMBER_INVALID_ERROR = 'Некорректный номер телефона';

interface ValidatePhoneNumberOptions {
    required?: boolean;
}

export const validatePhoneNumber = (value?: string | null, { required = false }: ValidatePhoneNumberOptions = {}) => {
    const normalizedPhoneNumber = normalizePhoneNumberInput(value ?? '');

    if (!normalizedPhoneNumber) {
        return required ? PHONE_NUMBER_REQUIRED_ERROR : undefined;
    }

    if (!isLibPhoneNumberValid(normalizedPhoneNumber)) {
        return PHONE_NUMBER_INVALID_ERROR;
    }

    return undefined;
};

export const isValidPhoneNumber = (value?: string | null) => {
    return validatePhoneNumber(value) === undefined;
};
